var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stream-chat-ctrl"},[_vm._m(0),_c('main',[_c('button',{on:{"click":function($event){return _vm.$emit('on-clear-chat')}}},[_vm._v("Очистить чат")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('h2',[_vm._v("Управление чатом")])])
}]

export { render, staticRenderFns }